import type { ApiStockAvailableLot, StockAvailableLotFilter } from "../../../api/lots";
import type { StockKanbanContainer } from "../../../api/stockKanbanContainers";

/*
 * Комплектование КАНБАН — только партийный учёт.
 * `stock/lots.getAvLots` может вернуть `LotCode === 0` (непартионный остаток по карточке ТМЦ).
 * Такие строки отфильтровываем в этом модуле (доменный сервис опций селекта, скан),
 * а не в shared-слое — другим сценариям LotCode=0 может быть нужен.
 */

/**
 * Признак партийного кода для комплектования КАНБАН. \
 * @warning `LotCode === 0` — непартионный остаток (`getAvLots`); для КАНБАН не комплектуем.
 * @param lotCode код партии
 */
export function isStockKanbanSupplyLotAccountingCode(lotCode: number): boolean {
    return lotCode !== 0;
}

/**
 * Фильтр доступных партий для контейнера КАНБАН (`stock/lots.getAvLots`).
 * @param container контейнер с ТМЦ и единицей измерения
 */
export function buildStockKanbanSupplyAvailableLotFilter(
    container: Pick<StockKanbanContainer, "StockobjCode" | "MeasureCode">,
): StockAvailableLotFilter {
    return {
        StockobjCode: container.StockobjCode,
        MeasCode: container.MeasureCode,
        DepotcardType: 1,
    };
}

/**
 * Оставляет только партийные остатки (`LotCode !== 0`) для выбора в комплектовании КАНБАН. \
 * Использовать как `transformOptions` у SearchSelect и при постобработке ответа `getAvLots`.
 * @param lots опции `getAvLots` / SearchSelect
 * @see isStockKanbanSupplyLotAccountingCode
 */
export function filterStockKanbanSupplyAvailableLots<T extends { LotCode: number }>(lots: T[]): T[] {
    return lots.filter((lot) => isStockKanbanSupplyLotAccountingCode(lot.LotCode));
}

/**
 * Доступный остаток партии в ЕИ потребности контейнера. \
 * Предпочитает `LotQtyRestInNeedMeas`, иначе `LotQtyRest`.
 * @param lot строка `getAvLots`
 */
export function resolveStockKanbanSupplyLotQtyRest(
    lot: Pick<ApiStockAvailableLot, "LotQtyRest" | "LotQtyRestInNeedMeas">,
): number {
    return lot.LotQtyRestInNeedMeas > 0 ? lot.LotQtyRestInNeedMeas : lot.LotQtyRest;
}
